'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Επιλέξτε ώρα'
};

exports['default'] = locale;